import React from 'react';
import { UserConferenceAdd } from './UserConferenceAdd';
import { ConferenceAccessTable } from './ConferenceAccessTable';
import { useGetAllConferenceUserAssignments } from '../api/conferenceuserassignments/getConferenceUserAssignments';

type Props = {
  userId: string;
};

export const UserConferences = ({ userId }: Props) => {
  const { data } = useGetAllConferenceUserAssignments(userId);
  return (
    <div className="bg-white shadow-sm border border-zinc-200 rounded-lg w-full font-lato mb-8">
      <UserConferenceAdd userId={userId} conferenceAccessItems={data?.pages[0].length} />
      <ConferenceAccessTable data={data} />
    </div>
  );
};
